import {
    Dialog,
    DialogActions,
    DialogBody,
    DialogContent,
    DialogSurface,
    DialogSurfaceProps,
    DialogTitle,
} from "@fluentui/react-components";
import { PcpPrimaryButton, PcpSecondaryButton } from "../PcpButtons";
import React, { CSSProperties } from "react";
import { mergeStyles } from "@fluentui/react";


const dialogActionsStyles: CSSProperties = {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: '10px',
};

const actionsContainerStyles: CSSProperties = {
    gridArea: "3 / 1 / 3 / 4",
    display: "flex",
    justifyContent: "center",
    width: "100%",
    marginTop: "32px",
};

const surfaceStyles: CSSProperties = {
    backdropFilter: 'blur(10px)',
    padding: '16px 32px',
}


interface PcpConfirmDialogProps {
    open: boolean;

    // strings
    title: string;
    content: string;
    confirmText: string;
    cancelText: string;

    // callbacks
    onClose: () => void;
    onConfirm: () => void;
}


const contentPaddingStyles = mergeStyles({
    padding: '24px',
})

export const PcpConfirmDialog = (props: PcpConfirmDialogProps): JSX.Element => (
    <Dialog open={props.open}>
        <PcpDialogSurface>
            <DialogBody style={{ gap: 0 }}>
                <DialogTitle style={{ marginBottom: 0 }} className={contentPaddingStyles}>{props.title}</DialogTitle>
                <DialogContent className={contentPaddingStyles}>
                    {props.content}
                </DialogContent>
                <DialogActions style={actionsContainerStyles}>
                    <div style={dialogActionsStyles}>
                        <PcpPrimaryButton onClick={() => props.onConfirm()}>{props.confirmText}</PcpPrimaryButton>
                        <PcpSecondaryButton onClick={() => props.onClose()}>{props.cancelText}</PcpSecondaryButton>
                    </div>
                </DialogActions>
            </DialogBody>
        </PcpDialogSurface>
    </Dialog>
);

export const PcpDialogSurface = (props: DialogSurfaceProps) => (
    <DialogSurface {...props} backdrop={{ style: surfaceStyles }} style={{ ...props.style, maxWidth: 'fit-content' }} />
);
